module.exports = __webpack_public_path__ + "img/535A2F_CDCA91_91915B_A4AC6F-256px.fe1b4f80.png";